const AddMemoIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width="128px"
      height="128px"
      viewBox="0 0 128 128"
    >
      <image
        id="image0"
        width="128"
        height="128"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA+VBMVEUAAAANTWwMUG0LT2sMT2wNTm8LT2wKUGwLT2zvz4/2z4T6x2XnoVPkrnHbtoD21Zf6xmLnnlDisoL4z4TmrXPnoFT8wlDolj3t6+rt6+ns6ur/29vt6+rt7e3s6urt6urh3t3h3t3h3t3i3tzh39zg3t7b29vi3t3h3t3V1dXk29vj49nh3tzh3t4LT2z7wVD8v0n5xGPyu2rqlTvokjbnlT35xGHroEoXVWoZVWr5xGRXcmFcdGH7wVHXrk8aVmodV2nhs01Yc2EYVWrt6+rh3t3o5uXn5eTo5ubn5OPs6unq6Ojm5OLq6eji397i39/t6unq6Of///+wOIOJAAAALnRSTlMAKLDyryfvrfEQrvTzrQ429/Y1rqvz/v7zyW4H0Bxtx/PxycdubAfQzwYcG23G/5mgywAAAAFiS0dEUg1gLZAAAAAJcEhZcwAAHYcAAB2HAY/l8WUAAAAHdElNRQfoCQMQFTAkLIsYAAABpUlEQVR42u3V6U7CQBQF4AqCCy64L7igiOJWKlTcEFRo3cDl/V/GSmutSUnvdGYyaTzn50m492tpcjUNQRAEQYZnJJVOj2bEdcz7s7qTbEZUx5yUPsiYqI45aXfIuKiOOboXUR0AyQFMTOaqhpOfIUYgcbrqWa1uOjmfmp6h7J/Ncywb0jUuzEHm5gnPn+dcFto16p4g+h0scC8L7WouwFyMBOT831y6M66Cg2N31x5gKRKw7P/mxh3SDA6O3d16gJVIwO+QVvt7xt19cHD8zgOYDACj9dDpNP/M5ejiAIQGAAAASA6gKymWFwAAAACARAHsR87YfIAnizs2F8BWDejaz5zh/AvUf4QAAACAcgBugWoAbgEAAACgHoBboBqAWwAAAACoB+AWqAbgFgAAAADqAbgFqgG4BQAoAqzK2f9CBqzJAbySAetyAD0yoLAhY3//jQzQNiUI+u8WHaAVtraFfokfnz3/+UkAN/yHIDzJARTl7N8hA3blAEpkwJ4cQJkM2D+Qsb9ySAZoRxIElWP6fucdnJSEfonF0zLD8yMIgiD/J1/77DZrAraP4AAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyNC0wOS0wM1QxNjoyMTo0OCswMDowMJpXcBQAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjQtMDktMDNUMTY6MjE6NDgrMDA6MDDrCsioAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="
      />
    </svg>
  );
};

export default AddMemoIcon;
